export default class LocationsBlock {
    constructor() {
        
    }
}

new LocationsBlock();


// WEBPACK FOOTER //
// ../views/modules/locations-block/assets/js/locations-block.js